import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../../__root"

/**
 * Role detail -- `/settings/roles/$roleId`. Page body lazy-loaded.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/settings/roles/$roleId",
	parseParams: (params) => ({ roleId: String(params.roleId) }),
	stringifyParams: (params) => ({ roleId: String(params.roleId) }),
	component: lazyRouteComponent(() => import("./$roleId.page")),
})
